import { Link, useNavigate, useParams } from "react-router-dom";
import styles from "./customersignup.module.css";
import { useState, forwardRef } from "react";
import Loader from "../../../admin/components/Loader";
import { Home } from "react-feather";
import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { usePlacesWidget } from "react-google-autocomplete";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import { useEffect } from "react";
import axios from "axios";

const CustomInput = forwardRef((props, ref) => (<TextField {...props} inputRef={ref} id="outlined-basic" label="Phone*" variant="outlined" />));

const CustomerSignup = () => {
  const navigate = useNavigate();
  const { str } = useParams();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [companyDetails, setCompanyDetails] = useState(null);
  const [isRegCompany, setIsRegCompany] = useState("");

  const { register, handleSubmit, setValue, control, watch, formState: { errors } } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    if (str) {
      axios.get(process.env.REACT_APP_API_URL + "v1/get-company-details/" + str).then((response) => {
        if (response.data.status === "SUCCESS") {
          if (response.data.data) {
            setCompanyDetails(response.data.data);
          } else {
            setTimeout(() => {
              navigate("/");
            }, 100);
          }
        }
        if (response.data.status === "ERROR") {
          setTimeout(() => {
            navigate("/");
          }, 100);
        }
      }).catch((error) => {
        setTimeout(() => {
          navigate("/");
        }, 100);
      });
    }
  }, [str, navigate]);

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address", place.formatted_address);

      setValue("latitude", place.geometry.location.lat());
      setValue("longitude", place.geometry.location.lng());

      place.address_components.forEach((item) => {
        if (item.types.indexOf("postal_code") > -1) {
          setValue("post_code", item.long_name);
        }
      });
    },
    options: {
      types: ["address"],
      componentRestrictions: { country: "GB" }
    },
  });

  async function onSubmit(data) {
    data = { ...data, utoken: companyDetails?.utoken };
    setLoading(true);
    setErrorMsg("");

    return axios.post(process.env.REACT_APP_API_URL + "v1/customer-signup", data).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        navigate("/");
      }
      if (response.data.status === "ERROR") {
        setErrorMsg(response?.data?.message);
      }
    }).catch((error) => {
      if (error && error?.response && error?.response?.data && error?.response?.data?.message) {
        setErrorMsg(error?.response?.data?.message);
      }
      setLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.LoginFormSec}`}>

        <div className={`${styles.LohinForm}`}>
          <Link to={"/"} className={`${styles.BackHomeBU}`}><Home />Back to home</Link>
          <h2 className={`${styles.BookingFormTitle} ${styles.Heading}`}>{companyDetails?.company_name}</h2>
          <p className={`${styles.LoginformSmTitle}`}>Create a customer account</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <p className={`${styles.ErrorM}`}>{errorMsg}</p>
            <div className={`${styles.FormRow}`}>
              <div className={`${styles.FormGroupFull} FormGroup`}>
                <Controller
                  control={control}
                  {...register("name", { required: "This field is Required" })}
                  render={({ field }) => (<TextField {...field} label="Name*" variant="outlined" />)}
                />
                {errors.name && (<span className={`${styles.ErrorM}`}>{errors?.name?.message}</span>)}
              </div>
              <div className={`${styles.FormGroupHalf} FormGroup`}>
                <Controller
                  control={control}
                  {...register("email", {
                    required: "This field is Required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" />)}
                />
                {errors.email && (<span className={`${styles.ErrorM}`}>{errors.email.message}</span>)}
              </div>
              <div className={`${styles.FormGroupHalf} FormGroup`}>
                <Controller
                  control={control}
                  {...register("phone", {
                    required: "This field is Required",
                    validate: isValidPhoneNumber,
                  })}
                  render={({ field }) => (<PhoneInput {...field} defaultCountry="GB" inputComponent={CustomInput} />)}
                />
                {errors.phone && errors.phone.type !== "validate" && (<span className={`${styles.ErrorM}`}>{errors.phone.message}</span>)}
                {errors.phone && errors.phone.type === "validate" && (<span className={`${styles.ErrorM}`}>Please enter valid phone</span>)}
              </div>
              <div className={`${styles.FormGroupHalf} FormGroup`}>
                <Controller
                  {...register("password", { required: "This field is Required" })}
                  control={control}
                  render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
                />
                {errors.password && (<span className={`${styles.ErrorM}`}>{errors.password.message}</span>)}
              </div>
              <div className={`${styles.FormGroupHalf} FormGroup`}>
                <Controller
                  {...register("conf_password", {
                    required: "This field is Required",
                    validate: (val) => {
                      if (watch("password") !== val) {
                        return "Your passwords do no match";
                      }
                    },
                  })}
                  control={control}
                  render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" />)}
                />
                {errors.conf_password && (<span className={`${styles.ErrorM}`}>{errors?.conf_password?.message}</span>)}
              </div>
              <div className={`${styles.FormGroupHalf} FormGroup`}>
                <Controller
                  control={control}
                  {...register("address", { required: "This field is Required" })}
                  render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={ref} placeholder="" />)}
                />
                {errors.address && (<span className={`${styles.ErrorM}`}>{errors.address.message}</span>)}
              </div>
              <div className={`${styles.FormGroupHalf} FormGroup`}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Do you have a Registered Company?*</InputLabel>
                  <Controller
                    control={control}
                    {...register("registered_company", {
                      required: "This field is Required",
                    })}
                    render={({ field }) => (<Select
                      {...field}
                      label="Do you have a Registered Company?*"
                      onChange={(e) => {
                        field.onChange(e);
                        setIsRegCompany(e.target.value);
                      }}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>)}
                  />
                </FormControl>
                {errors.registered_company && (<span className={`${styles.ErrorM}`}>{errors.registered_company.message}</span>)}
              </div>
              {isRegCompany === "Yes" && (<>
                <div className={`${styles.FormGroupHalf} FormGroup`}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">If Yes, are you shipping the goods in the name of the company?*</InputLabel>
                    <Controller
                      control={control}
                      {...register("company_shipping", {
                        required: "This field is Required",
                      })}
                      render={({ field }) => (<Select {...field} label="If Yes, are you shipping the goods in the name of the company?*">
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>)}
                    />
                  </FormControl>
                  {errors.company_shipping && (<span className={`ErrorM`}>{errors?.company_shipping?.message}</span>)}
                </div>
                <div className={`${styles.FormGroupHalf} FormGroup`}>
                  <Controller
                    control={control}
                    {...register("company_name", {
                      required: "This field is Required",
                    })}
                    render={({ field }) => (<TextField {...field} label="Registered Company Name*" variant="outlined" />)}
                  />
                  {errors.company_name && (<span className={`ErrorM`}>{errors?.company_name?.message}</span>)}
                </div>
              </>)}
              <div>
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register('terms', { required: 'You must accept the terms and conditions' })}
                        error={!!errors.terms}
                      />
                    }
                    label={<>
                      I agree to the{' '}
                      <Link to="/terms" target="_blank" rel="noopener noreferrer" className={`${styles.ForhotPassText}`}>
                        Terms and Conditions
                      </Link>
                    </>
                    }
                  />
                </FormControl>
                {errors.terms && (<span className={`${styles.ErrorM}`}>{errors?.terms?.message}</span>)}
              </div>
            </div>

            <button type="submit" className={`${styles.LoginBU}`}>
              <span>Register</span>
            </button>

            <p className={`${styles.LoginFormSText}`}>Already have an account? <Link to={"/sign-in"} className={`${styles.ForhotPassText}`}>Login</Link></p>
          </form>
        </div>
      </div>

      <div className={`${styles.LoginBGSec}`}>
        <img src="/images/loginBG1.jpg" alt="" />
      </div>
    </div>
  </>);
}

export default CustomerSignup;